import type { IPageViewTelemetry } from '@microsoft/1ds-analytics-web-js';
import { LogRow } from './logger.log-row';
import { GlobalVariables } from 'app/services/globals';

export class PageViewRow extends LogRow {
    constructor(
        private name: string,
        private url: string,
        properties?: Record<string, unknown>,
        private measurements?: { [key: string]: number },
        private duration?: number) {
        super(properties);
    }

    public generateLoggingEntry(): IPageViewTelemetry {
        return { name: this.name, uri: this.url, measurements: this.measurements, properties: { ...this.properties, duration: this.duration } };
    }

    public pushToAppInsights(): void {
        if (GlobalVariables.enableAriaLogger) {
            oneDSWeb.trackPageView(this.generateLoggingEntry());
        } else {
            appInsights.trackPageView(this.name, this.url, this.properties, this.measurements, this.duration);
        }
    }
}
